/* eslint-disable max-len */
/* eslint-disable sort-keys-fix/sort-keys-fix */
export const saasOpsMessages = {
    'SaasOps.automationIssue.title': 'Automation Issue',
    'SaasOps.integration.automation.error.message':
        'An error ocurred while running this automated workflow. This may be due to permission issue or a problem with the specific app or user.<br/><br/>Please contact support for further assistance.',
    'SaasOps.integrationCards.moreDetails':
        'More details about {{displayName}} integration.',
    'SaasOps.howTo': 'How to {{action}} a user using SaaS Ops Integration.',
    'SaasOps.integration.error.issue': 'An integration issue was detected',
    'SaasOps.integration.error.message':
        'We’ve identified a problem with the integration that prevents it from working as expected. Integration issues are usually related to authentication problems or API permissions.<br/><br/>Please try re-authenticating your connector. If the problem continues, please contact support for assistance.',
    'SaasOps.integrationStatus': 'SaaS Ops Integration Status',
    'SaasOps.state.integrated': 'Integrated',
    'SaasOps.state.connected': 'Connected',
    'SaasOps.connectionError': 'Error',
    'SaasOps.title': 'SaaS Ops',

    // Integration
    'SaasOps.integration.connection.success':
        '{{appName}} has been successfully configured.',
    'SaasOps.integration.card.availableActions.title':
        'Available SaaS Ops Actions',
    'SaasOps.integration.card.availableActions.offboard.badge': 'offboard',
    'SaasOps.integration.card.availableActions.onboard.badge': 'onboard',
    'SaasOps.integration.card.availableActions.licensing.badge': 'licensing',

    // SaaS Ops Licenses
    'SaasOps.licenses.total_one': '{{count}} License',
    'SaasOps.licenses.total_other': '{{count}} Licenses',
    'SaasOps.licenses.total.undetected_one': '{{count}} Undetected License',
    'SaasOps.licenses.total.undetected_other': '{{count}} Undetected Licenses',
    'SaasOps.licenses.total.underutilized_one':
        '{{count}} Underutilized License',
    'SaasOps.licenses.total.underutilized_other':
        '{{count}} Underutilized Licenses',

    // SaaS Ops Actions - general
    'SaasOps.form.button.reviewLater': 'Review Later',
    'SaasOps.appSelection.numberOfAppsSelected_one':
        '{{count}} of {{rowCount}} application selected',
    'SaasOps.appSelection.numberOfAppsSelected_other':
        '{{count}} of {{rowCount}} applications selected',
    'SaasOps.quickTips.tipOne':
        'Each application will be completed independently before moving on to the next.',
    'SaasOps.quickTips.tipTwo':
        'This process may take a while depending on the integration.',
    'SaasOps.quickTips.tipThree':
        'Navigating away may disrupt the process, you can validate with your integration’s audit log.',

    // Offboarding
    'SaasOps.offboard.title': 'Offboard',
    'SaasOps.offboard.selectUsersAndApps':
        'Select the users you wish to offboard and the applications assigned to them.',
    'SaasOps.offboard.selectUsers':
        'Please select the users first to view the applications assigned to them.',
    'SaasOps.offboard.selectApps':
        'Review the assigned applications to ensure the appropriate offboarding process for the selected users.',
    'SaasOps.offboard.numberOfAppsSelected_one':
        '{{count}} of {{rowCount}} application selected',
    'SaasOps.offboard.numberOfAppsSelected_other':
        '{{count}} of {{rowCount}} applications selected',
    'SaasOps.offboard.appsCompleted':
        '{{completedAppsCount}} of {{totalAppsCount}} apps offboard done.',

    'SaasOps.offboard.success': 'Successfully offboarded user.',
    'SaasOps.offboard.failed': 'Failed to offboard user.',
    'SaasOps.offboard.completed': 'Offboarding Completed',
    'SaasOps.offboard.inProgress': 'Offboarding in Progress',
    'SaasOps.offboard.stopped': 'Offboarding Stopped',
    'SaasOps.offboard.user.appOverview':
        'Revoke access, transfer resource ownership and back up critical data.',

    // Onboarding
    'SaasOps.onboard.title': 'Onboard',
    'SaasOps.onboard.intro.partOne': 'To start the onboarding process:',
    'SaasOps.onboard.intro.partTwo':
        '<span style="font-weight:600;">Enter user details</span>: Provide the first name, last name, and email of the user to be onboarded.',
    'SaasOps.onboard.intro.partThree':
        '<span style="font-weight:600;">Assign applications</span>: Select the required applications for the user from the table below.',
    'SaasOps.onboard.success': 'Successfully onboarded user.',
    'SaasOps.onboard.failed': 'Failed to onboard user.',
    'SaasOps.onboard.appsCompleted':
        '{{completedAppsCount}} of {{totalAppsCount}} apps onboard done.',
    'SaasOps.onboard.completed': 'Onboarding Completed',
    'SaasOps.onboard.inProgress': 'Onboarding in Progress',
    'SaasOps.onboard.stopped': 'Onboarding Stopped',
    'SaasOps.onboard.user.appOverview':
        'Set up accounts, customize your preferences, and get access to all the features you need.',

    // Empty state
    'SaasOps.emptyState.message':
        '**No SaaS Ops integration has been detected.**<br/> <br/>If your account isn’t configured or connected to a SaaS Ops integration, go to the Integrations page to set it up and access the full range of features.',
    'SaasOps.emptyState.setUpIntegration': 'Set Up Integration',

    // Licenses
    'SaasOps.licenses.notProvided':
        'This data is not provided by the integration.',

    // Skipping Apps Modal
    'SaasOps.skippingAppsModal.title': 'Skipping Applications',
    'SaasOps.skippingAppsModal.offboard.message_one':
        'We’ve noticed that {{count}} application was skipped. Would you like to remove it from the offboarding process, or review them again?',
    'SaasOps.skippingAppsModal.offboard.message_other':
        'We’ve noticed that {{count}} applications were skipped. Would you like to remove them from the offboarding process, or review them again?',
    'SaasOps.skippingAppsModal.onboard.message_one':
        'We’ve noticed that {{count}} application was skipped. Would you like to remove it from the onboarding process, or review them again?',
    'SaasOps.skippingAppsModal.onboard.message_other':
        'We’ve noticed that {{count}} applications were skipped. Would you like to remove them from the onboarding process, or review them again?',
    'SaasOps.skippingAppsModal.remove': 'Remove',
    'SaasOps.skippingAppsModal.reviewAgain': 'Review Again'
};
